import React, { useState } from 'react';
import { menu, close } from "../../assets"

function Menu({ menu, animation, onSelect }) {
    const menuKeys = Object.keys(menu).filter(function(k) {
        return menu[k].hasOwnProperty("hide");
    });
    return (
        <ul onClick={(e) => e.stopPropagation()} className={animation ? "menu__list slide-box" : "menu__list"}>
            {
                menuKeys.map((key, k, menuKeys) =>
                !menu[key].hide && <li onClick={()=> onSelect(false)} className={menuKeys.length - 1 === k ? "btn list__item":"list__item"} key={k}>
                    <a href={"#"+key.toLocaleLowerCase()} className="link"  >{menu[key].title}</a>
                </li>)
            }
        </ul>
    );
}

function BtnIcon({ onClick, icon, alt }) {
    return (
        <button onClick={onClick}  className="btn__icon">
            <img src={icon} alt={alt}/>
        </button>
    );
}

function Navbar({ data, smScreen, bgColor }) {
    const [toggleMenu, setToggleMenu] = useState(false);
    return (
        <div id="navbar" className="container-fluid" style={{background: !bgColor && 'none'}}>
            <div className="container">
                <div className="row">
                    <span id="brand" className='col-9 col-md-3'>
                        <a href="/" >
                            {data.Brand.URL === "" ? <h1>{data.Brand.name}</h1>
                            : <img src={data.Brand.URL} alt={data.Brand.name} />}
                        </a>
                    </span>
                    <nav id="Menu" className='col-3 col-md-9'>
                        {smScreen && (!toggleMenu && <BtnIcon onClick={()=> setToggleMenu(true)} icon={menu} alt="Menu"/>)}
                        { smScreen ? toggleMenu
                        && <div className="menuWrapper" onClick={() => setToggleMenu(false)}>
                            <BtnIcon onClick={()=> setToggleMenu(false)} icon={close} alt="Close Menu"/>
                            <Menu animation={toggleMenu} menu={data}  onSelect={setToggleMenu}/>
                            </div> : <Menu menu={data} animation={toggleMenu} onSelect={setToggleMenu}/>}
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Navbar
